import React, { Suspense } from 'react'

const CouponPopinBase = React.lazy(() => import('./CouponPopin'))

export const CouponPopin = () => (
  <Suspense fallback={null}>
    <CouponPopinBase />
  </Suspense>
)
